// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_17_2-typography {
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_17_2-typography[ant-5_24_1-click-animating-without-extra-node=true]::after,
.perxis-auto-1_17_2-typography > *[ant-5_24_1-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_17_2-typography .ant-5_24_1-wave {
  transition: none !important;
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography {
  margin-top: 0;
  margin-bottom: 0;
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography + h1.ant-5_24_1-typography, .perxis-auto-1_17_2-typography.ant-5_24_1-typography + h2.ant-5_24_1-typography, .perxis-auto-1_17_2-typography.ant-5_24_1-typography + h3.ant-5_24_1-typography, .perxis-auto-1_17_2-typography.ant-5_24_1-typography + h4.ant-5_24_1-typography, .perxis-auto-1_17_2-typography.ant-5_24_1-typography + h5.ant-5_24_1-typography {
  margin-top: 0;
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h1 {
  --perxis-auto-typography-h1-font-family-inner: var(
    --perxis-auto-typography-h1-font-family,
    var(--perxis-auto-root-typography-h1-font-family-inner)
  );
  --perxis-auto-typography-h1-font-weight-inner: var(
    --perxis-auto-typography-h1-font-weight,
    var(--perxis-auto-root-typography-h1-font-weight-inner)
  );
  --perxis-auto-typography-h1-letter-spacing-inner: var(
    --perxis-auto-typography-h1-letter-spacing,
    var(--perxis-auto-root-typography-h1-letter-spacing-inner)
  );
  --perxis-auto-typography-h1-text-transform-inner: var(
    --perxis-auto-typography-h1-text-transform,
    var(--perxis-auto-root-typography-h1-text-transform-inner)
  );
  --perxis-auto-typography-h1-font-variant-numeric-inner: var(
    --perxis-auto-typography-h1-font-variant-numeric,
    var(--perxis-auto-root-typography-h1-font-variant-numeric-inner)
  );
  --perxis-auto-typography-h1-font-size-xxl-inner: var(
    --perxis-auto-typography-h1-font-size-xxl,
    var(--perxis-auto-root-typography-h1-font-size-xxl-inner)
  );
  --perxis-auto-typography-h1-line-height-xxl-inner: var(
    --perxis-auto-typography-h1-line-height-xxl,
    var(--perxis-auto-root-typography-h1-line-height-xxl-inner)
  );
  --perxis-auto-typography-h1-font-size-xl-inner: var(
    --perxis-auto-typography-h1-font-size-xl,
    var(--perxis-auto-root-typography-h1-font-size-xl-inner)
  );
  --perxis-auto-typography-h1-line-height-xl-inner: var(
    --perxis-auto-typography-h1-line-height-xl,
    var(--perxis-auto-root-typography-h1-line-height-xl-inner)
  );
  --perxis-auto-typography-h1-font-size-lg-inner: var(
    --perxis-auto-typography-h1-font-size-lg,
    var(--perxis-auto-root-typography-h1-font-size-lg-inner)
  );
  --perxis-auto-typography-h1-line-height-lg-inner: var(
    --perxis-auto-typography-h1-line-height-lg,
    var(--perxis-auto-root-typography-h1-line-height-lg-inner)
  );
  --perxis-auto-typography-h1-font-size-md-inner: var(
    --perxis-auto-typography-h1-font-size-md,
    var(--perxis-auto-root-typography-h1-font-size-lg-inner)
  );
  --perxis-auto-typography-h1-line-height-md-inner: var(
    --perxis-auto-typography-h1-line-height-md,
    var(--perxis-auto-root-typography-h1-line-height-lg-inner)
  );
  --perxis-auto-typography-h1-font-size-sm-inner: var(
    --perxis-auto-typography-h1-font-size-sm,
    var(--perxis-auto-root-typography-h1-font-size-md-inner)
  );
  --perxis-auto-typography-h1-line-height-sm-inner: var(
    --perxis-auto-typography-h1-line-height-sm,
    var(--perxis-auto-root-typography-h1-line-height-md-inner)
  );
  --perxis-auto-typography-h1-font-size-xs-inner: var(
    --perxis-auto-typography-h1-font-size-xs,
    var(--perxis-auto-root-typography-h1-font-size-sm-inner)
  );
  --perxis-auto-typography-h1-line-height-xs-inner: var(
    --perxis-auto-typography-h1-line-height-xs,
    var(--perxis-auto-root-typography-h1-line-height-sm-inner)
  );
  --perxis-auto-typography-h1-font-size-xxs-inner: var(
    --perxis-auto-typography-h1-font-size-xxs,
    var(--perxis-auto-root-typography-h1-font-size-xs-inner)
  );
  --perxis-auto-typography-h1-line-height-xxs-inner: var(
    --perxis-auto-typography-h1-line-height-xxs,
    var(--perxis-auto-root-typography-h1-line-height-xs-inner)
  );
  font-family: var(--perxis-auto-typography-h1-font-family-inner);
  font-weight: var(--perxis-auto-typography-h1-font-weight-inner);
  text-transform: var(--perxis-auto-typography-h1-text-transform-inner);
  letter-spacing: var(--perxis-auto-typography-h1-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-typography-h1-font-variant-numeric-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h1 {
    font-size: var(--perxis-auto-typography-h1-font-size-xxl-inner);
    line-height: var(--perxis-auto-typography-h1-line-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h1 {
    font-size: var(--perxis-auto-typography-h1-font-size-xl-inner);
    line-height: var(--perxis-auto-typography-h1-line-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h1 {
    font-size: var(--perxis-auto-typography-h1-font-size-lg-inner);
    line-height: var(--perxis-auto-typography-h1-line-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h1 {
    font-size: var(--perxis-auto-typography-h1-font-size-md-inner);
    line-height: var(--perxis-auto-typography-h1-line-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h1 {
    font-size: var(--perxis-auto-typography-h1-font-size-sm-inner);
    line-height: var(--perxis-auto-typography-h1-line-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h1 {
    font-size: var(--perxis-auto-typography-h1-font-size-xs-inner);
    line-height: var(--perxis-auto-typography-h1-line-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h1, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h1 {
    font-size: var(--perxis-auto-typography-h1-font-size-xxs-inner);
    line-height: var(--perxis-auto-typography-h1-line-height-xxs-inner);
  }
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h2 {
  --perxis-auto-typography-h2-font-family-inner: var(
    --perxis-auto-typography-h2-font-family,
    var(--perxis-auto-root-typography-h2-font-family-inner)
  );
  --perxis-auto-typography-h2-font-weight-inner: var(
    --perxis-auto-typography-h2-font-weight,
    var(--perxis-auto-root-typography-h2-font-weight-inner)
  );
  --perxis-auto-typography-h2-letter-spacing-inner: var(
    --perxis-auto-typography-h2-letter-spacing,
    var(--perxis-auto-root-typography-h2-letter-spacing-inner)
  );
  --perxis-auto-typography-h2-text-transform-inner: var(
    --perxis-auto-typography-h2-text-transform,
    var(--perxis-auto-root-typography-h2-text-transform-inner)
  );
  --perxis-auto-typography-h2-font-variant-numeric-inner: var(
    --perxis-auto-typography-h2-font-variant-numeric,
    var(--perxis-auto-root-typography-h2-font-variant-numeric-inner)
  );
  --perxis-auto-typography-h2-font-size-xxl-inner: var(
    --perxis-auto-typography-h2-font-size-xxl,
    var(--perxis-auto-root-typography-h2-font-size-xxl-inner)
  );
  --perxis-auto-typography-h2-line-height-xxl-inner: var(
    --perxis-auto-typography-h2-line-height-xxl,
    var(--perxis-auto-root-typography-h2-line-height-xxl-inner)
  );
  --perxis-auto-typography-h2-font-size-xl-inner: var(
    --perxis-auto-typography-h2-font-size-xl,
    var(--perxis-auto-root-typography-h2-font-size-xxl-inner)
  );
  --perxis-auto-typography-h2-line-height-xl-inner: var(
    --perxis-auto-typography-h2-line-height-xl,
    var(--perxis-auto-root-typography-h2-line-height-xxl-inner)
  );
  --perxis-auto-typography-h2-font-size-lg-inner: var(
    --perxis-auto-typography-h2-font-size-lg,
    var(--perxis-auto-root-typography-h2-font-size-xl-inner)
  );
  --perxis-auto-typography-h2-line-height-lg-inner: var(
    --perxis-auto-typography-h2-line-height-lg,
    var(--perxis-auto-root-typography-h2-line-height-xl-inner)
  );
  --perxis-auto-typography-h2-font-size-md-inner: var(
    --perxis-auto-typography-h2-font-size-md,
    var(--perxis-auto-root-typography-h2-font-size-lg-inner)
  );
  --perxis-auto-typography-h2-line-height-md-inner: var(
    --perxis-auto-typography-h2-line-height-md,
    var(--perxis-auto-root-typography-h2-line-height-lg-inner)
  );
  --perxis-auto-typography-h2-font-size-sm-inner: var(
    --perxis-auto-typography-h2-font-size-sm,
    var(--perxis-auto-root-typography-h2-font-size-md-inner)
  );
  --perxis-auto-typography-h2-line-height-sm-inner: var(
    --perxis-auto-typography-h2-line-height-sm,
    var(--perxis-auto-root-typography-h2-line-height-md-inner)
  );
  --perxis-auto-typography-h2-font-size-xs-inner: var(
    --perxis-auto-typography-h2-font-size-xs,
    var(--perxis-auto-root-typography-h2-font-size-sm-inner)
  );
  --perxis-auto-typography-h2-line-height-xs-inner: var(
    --perxis-auto-typography-h2-line-height-xs,
    var(--perxis-auto-root-typography-h2-line-height-sm-inner)
  );
  --perxis-auto-typography-h2-font-size-xxs-inner: var(
    --perxis-auto-typography-h2-font-size-xxs,
    var(--perxis-auto-root-typography-h2-font-size-xs-inner)
  );
  --perxis-auto-typography-h2-line-height-xxs-inner: var(
    --perxis-auto-typography-h2-line-height-xxs,
    var(--perxis-auto-root-typography-h2-line-height-xs-inner)
  );
  font-family: var(--perxis-auto-typography-h2-font-family-inner);
  font-weight: var(--perxis-auto-typography-h2-font-weight-inner);
  text-transform: var(--perxis-auto-typography-h2-text-transform-inner);
  letter-spacing: var(--perxis-auto-typography-h2-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-typography-h2-font-variant-numeric-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h2 {
    font-size: var(--perxis-auto-typography-h2-font-size-xxl-inner);
    line-height: var(--perxis-auto-typography-h2-line-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h2 {
    font-size: var(--perxis-auto-typography-h2-font-size-xl-inner);
    line-height: var(--perxis-auto-typography-h2-line-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h2 {
    font-size: var(--perxis-auto-typography-h2-font-size-lg-inner);
    line-height: var(--perxis-auto-typography-h2-line-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h2 {
    font-size: var(--perxis-auto-typography-h2-font-size-md-inner);
    line-height: var(--perxis-auto-typography-h2-line-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h2 {
    font-size: var(--perxis-auto-typography-h2-font-size-sm-inner);
    line-height: var(--perxis-auto-typography-h2-line-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h2 {
    font-size: var(--perxis-auto-typography-h2-font-size-xs-inner);
    line-height: var(--perxis-auto-typography-h2-line-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h2, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h2 {
    font-size: var(--perxis-auto-typography-h2-font-size-xxs-inner);
    line-height: var(--perxis-auto-typography-h2-line-height-xxs-inner);
  }
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h3 {
  --perxis-auto-typography-h3-font-family-inner: var(
    --perxis-auto-typography-h3-font-family,
    var(--perxis-auto-root-typography-h3-font-family-inner)
  );
  --perxis-auto-typography-h3-font-variant-numeric-inner: var(
    --perxis-auto-typography-h3-font-variant-numeric,
    var(--perxis-auto-root-typography-h3-font-variant-numeric-inner)
  );
  --perxis-auto-typography-h3-font-weight-inner: var(
    --perxis-auto-typography-h3-font-weight,
    var(--perxis-auto-root-typography-h3-font-weight-inner)
  );
  --perxis-auto-typography-h3-letter-spacing-inner: var(
    --perxis-auto-typography-h3-letter-spacing,
    var(--perxis-auto-root-typography-h3-letter-spacing-inner)
  );
  --perxis-auto-typography-h3-text-transform-inner: var(
    --perxis-auto-typography-h3-text-transform,
    var(--perxis-auto-root-typography-h3-text-transform-inner)
  );
  --perxis-auto-typography-h3-font-size-xxl-inner: var(
    --perxis-auto-typography-h3-font-size-xxl,
    var(--perxis-auto-root-typography-h3-font-size-xxl-inner)
  );
  --perxis-auto-typography-h3-line-height-xxl-inner: var(
    --perxis-auto-typography-h3-line-height-xxl,
    var(--perxis-auto-root-typography-h3-line-height-xxl-inner)
  );
  --perxis-auto-typography-h3-font-size-xl-inner: var(
    --perxis-auto-typography-h3-font-size-xl,
    var(--perxis-auto-root-typography-h3-font-size-xxl-inner)
  );
  --perxis-auto-typography-h3-line-height-xl-inner: var(
    --perxis-auto-typography-h3-line-height-xl,
    var(--perxis-auto-root-typography-h3-line-height-xxl-inner)
  );
  --perxis-auto-typography-h3-font-size-lg-inner: var(
    --perxis-auto-typography-h3-font-size-lg,
    var(--perxis-auto-root-typography-h3-font-size-xl-inner)
  );
  --perxis-auto-typography-h3-line-height-lg-inner: var(
    --perxis-auto-typography-h3-line-height-lg,
    var(--perxis-auto-root-typography-h3-line-height-xl-inner)
  );
  --perxis-auto-typography-h3-font-size-md-inner: var(
    --perxis-auto-typography-h3-font-size-md,
    var(--perxis-auto-root-typography-h3-font-size-lg-inner)
  );
  --perxis-auto-typography-h3-line-height-md-inner: var(
    --perxis-auto-typography-h3-line-height-md,
    var(--perxis-auto-root-typography-h3-line-height-lg-inner)
  );
  --perxis-auto-typography-h3-font-size-sm-inner: var(
    --perxis-auto-typography-h3-font-size-sm,
    var(--perxis-auto-root-typography-h3-font-size-md-inner)
  );
  --perxis-auto-typography-h3-line-height-sm-inner: var(
    --perxis-auto-typography-h3-line-height-sm,
    var(--perxis-auto-root-typography-h3-line-height-md-inner)
  );
  --perxis-auto-typography-h3-font-size-xs-inner: var(
    --perxis-auto-typography-h3-font-size-xs,
    var(--perxis-auto-root-typography-h3-font-size-sm-inner)
  );
  --perxis-auto-typography-h3-line-height-xs-inner: var(
    --perxis-auto-typography-h3-line-height-xs,
    var(--perxis-auto-root-typography-h3-line-height-sm-inner)
  );
  --perxis-auto-typography-h3-font-size-xxs-inner: var(
    --perxis-auto-typography-h3-font-size-xxs,
    var(--perxis-auto-root-typography-h3-font-size-xs-inner)
  );
  --perxis-auto-typography-h3-line-height-xxs-inner: var(
    --perxis-auto-typography-h3-line-height-xxs,
    var(--perxis-auto-root-typography-h3-line-height-xs-inner)
  );
  font-family: var(--perxis-auto-typography-h3-font-family-inner);
  font-weight: var(--perxis-auto-typography-h3-font-weight-inner);
  text-transform: var(--perxis-auto-typography-h3-text-transform-inner);
  letter-spacing: var(--perxis-auto-typography-h3-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-typography-h3-font-variant-numeric-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h3 {
    font-size: var(--perxis-auto-typography-h3-font-size-xxl-inner);
    line-height: var(--perxis-auto-typography-h3-line-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h3 {
    font-size: var(--perxis-auto-typography-h3-font-size-xl-inner);
    line-height: var(--perxis-auto-typography-h3-line-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h3 {
    font-size: var(--perxis-auto-typography-h3-font-size-lg-inner);
    line-height: var(--perxis-auto-typography-h3-line-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h3 {
    font-size: var(--perxis-auto-typography-h3-font-size-md-inner);
    line-height: var(--perxis-auto-typography-h3-line-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h3 {
    font-size: var(--perxis-auto-typography-h3-font-size-sm-inner);
    line-height: var(--perxis-auto-typography-h3-line-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h3 {
    font-size: var(--perxis-auto-typography-h3-font-size-xs-inner);
    line-height: var(--perxis-auto-typography-h3-line-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h3, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h3 {
    font-size: var(--perxis-auto-typography-h3-font-size-xxs-inner);
    line-height: var(--perxis-auto-typography-h3-line-height-xxs-inner);
  }
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h4 {
  --perxis-auto-typography-h4-font-family-inner: var(
    --perxis-auto-typography-h4-font-family,
    var(--perxis-auto-root-typography-h4-font-family-inner)
  );
  --perxis-auto-typography-h4-font-variant-numeric-inner: var(
    --perxis-auto-typography-h4-font-variant-numeric,
    var(--perxis-auto-root-typography-h4-font-variant-numeric-inner)
  );
  --perxis-auto-typography-h4-font-weight-inner: var(
    --perxis-auto-typography-h4-font-weight,
    var(--perxis-auto-root-typography-h4-font-weight-inner)
  );
  --perxis-auto-typography-h4-letter-spacing-inner: var(
    --perxis-auto-typography-h4-letter-spacing,
    var(--perxis-auto-root-typography-h4-letter-spacing-inner)
  );
  --perxis-auto-typography-h4-text-transform-inner: var(
    --perxis-auto-typography-h4-text-transform,
    var(--perxis-auto-root-typography-h4-text-transform-inner)
  );
  --perxis-auto-typography-h4-font-size-xxl-inner: var(
    --perxis-auto-typography-h4-font-size-xxl,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  --perxis-auto-typography-h4-line-height-xxl-inner: var(
    --perxis-auto-typography-h4-line-height-xxl,
    var(--perxis-auto-root-typography-h4-line-height-xxl-inner)
  );
  --perxis-auto-typography-h4-font-size-xl-inner: var(
    --perxis-auto-typography-h4-font-size-xl,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  --perxis-auto-typography-h4-line-height-xl-inner: var(
    --perxis-auto-typography-h4-line-height-xl,
    var(--perxis-auto-root-typography-h4-line-height-xxl-inner)
  );
  --perxis-auto-typography-h4-font-size-lg-inner: var(
    --perxis-auto-typography-h4-font-size-lg,
    var(--perxis-auto-root-typography-h4-font-size-xl-inner)
  );
  --perxis-auto-typography-h4-line-height-lg-inner: var(
    --perxis-auto-typography-h4-line-height-lg,
    var(--perxis-auto-root-typography-h4-line-height-xl-inner)
  );
  --perxis-auto-typography-h4-font-size-md-inner: var(
    --perxis-auto-typography-h4-font-size-md,
    var(--perxis-auto-root-typography-h4-font-size-lg-inner)
  );
  --perxis-auto-typography-h4-line-height-md-inner: var(
    --perxis-auto-typography-h4-line-height-md,
    var(--perxis-auto-root-typography-h4-line-height-lg-inner)
  );
  --perxis-auto-typography-h4-font-size-sm-inner: var(
    --perxis-auto-typography-h4-font-size-sm,
    var(--perxis-auto-root-typography-h4-font-size-md-inner)
  );
  --perxis-auto-typography-h4-line-height-sm-inner: var(
    --perxis-auto-typography-h4-line-height-sm,
    var(--perxis-auto-root-typography-h4-line-height-md-inner)
  );
  --perxis-auto-typography-h4-font-size-xs-inner: var(
    --perxis-auto-typography-h4-font-size-xs,
    var(--perxis-auto-root-typography-h4-font-size-sm-inner)
  );
  --perxis-auto-typography-h4-line-height-xs-inner: var(
    --perxis-auto-typography-h4-line-height-xs,
    var(--perxis-auto-root-typography-h4-line-height-sm-inner)
  );
  --perxis-auto-typography-h4-font-size-xxs-inner: var(
    --perxis-auto-typography-h4-font-size-xxs,
    var(--perxis-auto-root-typography-h4-font-size-xs-inner)
  );
  --perxis-auto-typography-h4-line-height-xxs-inner: var(
    --perxis-auto-typography-h4-line-height-xxs,
    var(--perxis-auto-root-typography-h4-line-height-xs-inner)
  );
  font-family: var(--perxis-auto-typography-h4-font-family-inner);
  font-weight: var(--perxis-auto-typography-h4-font-weight-inner);
  text-transform: var(--perxis-auto-typography-h4-text-transform-inner);
  letter-spacing: var(--perxis-auto-typography-h4-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-typography-h4-font-variant-numeric-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h4 {
    font-size: var(--perxis-auto-typography-h4-font-size-xxl-inner);
    line-height: var(--perxis-auto-typography-h4-line-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h4 {
    font-size: var(--perxis-auto-typography-h4-font-size-xl-inner);
    line-height: var(--perxis-auto-typography-h4-line-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h4 {
    font-size: var(--perxis-auto-typography-h4-font-size-lg-inner);
    line-height: var(--perxis-auto-typography-h4-line-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h4 {
    font-size: var(--perxis-auto-typography-h4-font-size-md-inner);
    line-height: var(--perxis-auto-typography-h4-line-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h4 {
    font-size: var(--perxis-auto-typography-h4-font-size-sm-inner);
    line-height: var(--perxis-auto-typography-h4-line-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h4 {
    font-size: var(--perxis-auto-typography-h4-font-size-xs-inner);
    line-height: var(--perxis-auto-typography-h4-line-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h4, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h4 {
    font-size: var(--perxis-auto-typography-h4-font-size-xxs-inner);
    line-height: var(--perxis-auto-typography-h4-line-height-xxs-inner);
  }
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h5 {
  --perxis-auto-typography-h5-font-family-inner: var(
    --perxis-auto-typography-h5-font-family,
    var(--perxis-auto-root-typography-h5-font-family-inner)
  );
  --perxis-auto-typography-h5-font-variant-numeric-inner: var(
    --perxis-auto-typography-h5-font-variant-numeric,
    var(--perxis-auto-root-typography-h3-font-variant-numeric-inner)
  );
  --perxis-auto-typography-h5-font-weight-inner: var(
    --perxis-auto-typography-h5-font-weight,
    var(--perxis-auto-root-typography-h5-font-weight-inner)
  );
  --perxis-auto-typography-h5-letter-spacing-inner: var(
    --perxis-auto-typography-h5-letter-spacing,
    var(--perxis-auto-root-typography-h5-letter-spacing-inner)
  );
  --perxis-auto-typography-h5-text-transform-inner: var(
    --perxis-auto-typography-h5-text-transform,
    var(--perxis-auto-root-typography-h5-text-transform-inner)
  );
  --perxis-auto-typography-h5-font-size-xxl-inner: var(
    --perxis-auto-typography-h5-font-size-xxl,
    var(--perxis-auto-root-typography-h5-font-size-xxl-inner)
  );
  --perxis-auto-typography-h5-line-height-xxl-inner: var(
    --perxis-auto-typography-h5-line-height-xxl,
    var(--perxis-auto-root-typography-h5-line-height-xxl-inner)
  );
  --perxis-auto-typography-h5-font-size-xl-inner: var(
    --perxis-auto-typography-h5-font-size-xl,
    var(--perxis-auto-root-typography-h5-font-size-xxl-inner)
  );
  --perxis-auto-typography-h5-line-height-xl-inner: var(
    --perxis-auto-typography-h5-line-height-xl,
    var(--perxis-auto-root-typography-h5-line-height-xxl-inner)
  );
  --perxis-auto-typography-h5-font-size-lg-inner: var(
    --perxis-auto-typography-h5-font-size-lg,
    var(--perxis-auto-root-typography-h5-font-size-xl-inner)
  );
  --perxis-auto-typography-h5-line-height-lg-inner: var(
    --perxis-auto-typography-h5-line-height-lg,
    var(--perxis-auto-root-typography-h5-line-height-xl-inner)
  );
  --perxis-auto-typography-h5-font-size-md-inner: var(
    --perxis-auto-typography-h5-font-size-md,
    var(--perxis-auto-root-typography-h5-font-size-lg-inner)
  );
  --perxis-auto-typography-h5-line-height-md-inner: var(
    --perxis-auto-typography-h5-line-height-md,
    var(--perxis-auto-root-typography-h5-line-height-lg-inner)
  );
  --perxis-auto-typography-h5-font-size-sm-inner: var(
    --perxis-auto-typography-h5-font-size-sm,
    var(--perxis-auto-root-typography-h5-font-size-md-inner)
  );
  --perxis-auto-typography-h5-line-height-sm-inner: var(
    --perxis-auto-typography-h5-line-height-sm,
    var(--perxis-auto-root-typography-h5-line-height-md-inner)
  );
  --perxis-auto-typography-h5-font-size-xs-inner: var(
    --perxis-auto-typography-h5-font-size-xs,
    var(--perxis-auto-root-typography-h5-font-size-sm-inner)
  );
  --perxis-auto-typography-h5-line-height-xs-inner: var(
    --perxis-auto-typography-h5-line-height-xs,
    var(--perxis-auto-root-typography-h5-line-height-sm-inner)
  );
  --perxis-auto-typography-h5-font-size-xxs-inner: var(
    --perxis-auto-typography-h5-font-size-xxs,
    var(--perxis-auto-root-typography-h5-font-size-xs-inner)
  );
  --perxis-auto-typography-h5-line-height-xxs-inner: var(
    --perxis-auto-typography-h5-line-height-xxs,
    var(--perxis-auto-root-typography-h5-line-height-xs-inner)
  );
  font-family: var(--perxis-auto-typography-h5-font-family-inner);
  font-weight: var(--perxis-auto-typography-h5-font-weight-inner);
  text-transform: var(--perxis-auto-typography-h5-text-transform-inner);
  letter-spacing: var(--perxis-auto-typography-h5-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-typography-h5-font-variant-numeric-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h5 {
    font-size: var(--perxis-auto-typography-h5-font-size-xxl-inner);
    line-height: var(--perxis-auto-typography-h5-line-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h5 {
    font-size: var(--perxis-auto-typography-h5-font-size-xl-inner);
    line-height: var(--perxis-auto-typography-h5-line-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h5 {
    font-size: var(--perxis-auto-typography-h5-font-size-lg-inner);
    line-height: var(--perxis-auto-typography-h5-line-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h5 {
    font-size: var(--perxis-auto-typography-h5-font-size-md-inner);
    line-height: var(--perxis-auto-typography-h5-line-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h5 {
    font-size: var(--perxis-auto-typography-h5-font-size-sm-inner);
    line-height: var(--perxis-auto-typography-h5-line-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h5 {
    font-size: var(--perxis-auto-typography-h5-font-size-xs-inner);
    line-height: var(--perxis-auto-typography-h5-line-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--h5, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--h5 {
    font-size: var(--perxis-auto-typography-h5-font-size-xxs-inner);
    line-height: var(--perxis-auto-typography-h5-line-height-xxs-inner);
  }
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--marker {
  --perxis-auto-typography-marker-font-family-inner: var(
    --perxis-auto-typography-marker-font-family,
    var(--perxis-auto-root-typography-marker-font-family-inner)
  );
  --perxis-auto-typography-marker-font-variant-numeric-inner: var(
    --perxis-auto-typography-marker-font-variant-numeric,
    var(--perxis-auto-root-typography-marker-font-variant-numeric-inner)
  );
  --perxis-auto-typography-marker-font-weight-inner: var(
    --perxis-auto-typography-marker-font-weight,
    var(--perxis-auto-root-typography-marker-font-weight-inner)
  );
  --perxis-auto-typography-marker-letter-spacing-inner: var(
    --perxis-auto-typography-marker-letter-spacing,
    var(--perxis-auto-root-typography-marker-letter-spacing-inner)
  );
  --perxis-auto-typography-marker-text-transform-inner: var(
    --perxis-auto-typography-marker-text-transform,
    var(--perxis-auto-root-typography-marker-text-transform-inner)
  );
  --perxis-auto-typography-marker-font-size-xxl-inner: var(
    --perxis-auto-typography-marker-font-size-xxl,
    var(--perxis-auto-root-typography-marker-font-size-xxl-inner)
  );
  --perxis-auto-typography-marker-line-height-xxl-inner: var(
    --perxis-auto-typography-marker-line-height-xxl,
    var(--perxis-auto-root-typography-marker-line-height-xxl-inner)
  );
  --perxis-auto-typography-marker-font-size-xl-inner: var(
    --perxis-auto-typography-marker-font-size-xl,
    var(--perxis-auto-root-typography-marker-font-size-xxl-inner)
  );
  --perxis-auto-typography-marker-line-height-xl-inner: var(
    --perxis-auto-typography-marker-line-height-xl,
    var(--perxis-auto-root-typography-marker-line-height-xxl-inner)
  );
  --perxis-auto-typography-marker-font-size-lg-inner: var(
    --perxis-auto-typography-marker-font-size-lg,
    var(--perxis-auto-root-typography-marker-font-size-xl-inner)
  );
  --perxis-auto-typography-marker-line-height-lg-inner: var(
    --perxis-auto-typography-marker-line-height-lg,
    var(--perxis-auto-root-typography-marker-line-height-xl-inner)
  );
  --perxis-auto-typography-marker-font-size-md-inner: var(
    --perxis-auto-typography-marker-font-size-md,
    var(--perxis-auto-root-typography-marker-font-size-lg-inner)
  );
  --perxis-auto-typography-marker-line-height-md-inner: var(
    --perxis-auto-typography-marker-line-height-md,
    var(--perxis-auto-root-typography-marker-line-height-lg-inner)
  );
  --perxis-auto-typography-marker-font-size-sm-inner: var(
    --perxis-auto-typography-marker-font-size-sm,
    var(--perxis-auto-root-typography-marker-font-size-md-inner)
  );
  --perxis-auto-typography-marker-line-height-sm-inner: var(
    --perxis-auto-typography-marker-line-height-sm,
    var(--perxis-auto-root-typography-marker-line-height-md-inner)
  );
  --perxis-auto-typography-marker-font-size-xs-inner: var(
    --perxis-auto-typography-marker-font-size-xs,
    var(--perxis-auto-root-typography-marker-font-size-sm-inner)
  );
  --perxis-auto-typography-marker-line-height-xs-inner: var(
    --perxis-auto-typography-marker-line-height-xs,
    var(--perxis-auto-root-typography-marker-line-height-sm-inner)
  );
  --perxis-auto-typography-marker-font-size-xxs-inner: var(
    --perxis-auto-typography-marker-font-size-xxs,
    var(--perxis-auto-root-typography-marker-font-size-xs-inner)
  );
  --perxis-auto-typography-marker-line-height-xxs-inner: var(
    --perxis-auto-typography-marker-line-height-xxs,
    var(--perxis-auto-root-typography-marker-line-height-xs-inner)
  );
  font-family: var(--perxis-auto-typography-marker-font-family-inner);
  font-weight: var(--perxis-auto-typography-marker-font-weight-inner);
  text-transform: var(--perxis-auto-typography-marker-text-transform-inner);
  letter-spacing: var(--perxis-auto-typography-marker-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-typography-marker-font-variant-numeric-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--marker {
    font-size: var(--perxis-auto-typography-marker-font-size-xxl-inner);
    line-height: var(--perxis-auto-typography-marker-line-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--marker {
    font-size: var(--perxis-auto-typography-marker-font-size-xl-inner);
    line-height: var(--perxis-auto-typography-marker-line-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--marker {
    font-size: var(--perxis-auto-typography-marker-font-size-lg-inner);
    line-height: var(--perxis-auto-typography-marker-line-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--marker {
    font-size: var(--perxis-auto-typography-marker-font-size-md-inner);
    line-height: var(--perxis-auto-typography-marker-line-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--marker {
    font-size: var(--perxis-auto-typography-marker-font-size-sm-inner);
    line-height: var(--perxis-auto-typography-marker-line-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--marker {
    font-size: var(--perxis-auto-typography-marker-font-size-xs-inner);
    line-height: var(--perxis-auto-typography-marker-line-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--marker, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--marker {
    font-size: var(--perxis-auto-typography-marker-font-size-xxs-inner);
    line-height: var(--perxis-auto-typography-marker-line-height-xxs-inner);
  }
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--main {
  --perxis-auto-typography-main-font-family-inner: var(
    --perxis-auto-typography-main-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-typography-main-font-variant-numeric-inner: var(
    --perxis-auto-typography-main-font-variant-numeric,
    var(--perxis-auto-root-typography-main-font-variant-numeric-inner)
  );
  --perxis-auto-typography-main-font-weight-inner: var(
    --perxis-auto-typography-main-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-typography-main-letter-spacing-inner: var(
    --perxis-auto-typography-main-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-typography-main-text-transform-inner: var(
    --perxis-auto-typography-main-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-typography-main-font-size-xxl-inner: var(
    --perxis-auto-typography-main-font-size-xxl,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-typography-main-line-height-xxl-inner: var(
    --perxis-auto-typography-main-line-height-xxl,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-typography-main-font-size-xl-inner: var(
    --perxis-auto-typography-main-font-size-xl,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-typography-main-line-height-xl-inner: var(
    --perxis-auto-typography-main-line-height-xl,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-typography-main-font-size-lg-inner: var(
    --perxis-auto-typography-main-font-size-lg,
    var(--perxis-auto-root-typography-main-font-size-xl-inner)
  );
  --perxis-auto-typography-main-line-height-lg-inner: var(
    --perxis-auto-typography-main-line-height-lg,
    var(--perxis-auto-root-typography-main-line-height-xl-inner)
  );
  --perxis-auto-typography-main-font-size-md-inner: var(
    --perxis-auto-typography-main-font-size-md,
    var(--perxis-auto-root-typography-main-font-size-lg-inner)
  );
  --perxis-auto-typography-main-line-height-md-inner: var(
    --perxis-auto-typography-main-line-height-md,
    var(--perxis-auto-root-typography-main-line-height-lg-inner)
  );
  --perxis-auto-typography-main-font-size-sm-inner: var(
    --perxis-auto-typography-main-font-size-sm,
    var(--perxis-auto-root-typography-main-font-size-md-inner)
  );
  --perxis-auto-typography-main-line-height-sm-inner: var(
    --perxis-auto-typography-main-line-height-sm,
    var(--perxis-auto-root-typography-main-line-height-md-inner)
  );
  --perxis-auto-typography-main-font-size-xs-inner: var(
    --perxis-auto-typography-main-font-size-xs,
    var(--perxis-auto-root-typography-main-font-size-sm-inner)
  );
  --perxis-auto-typography-main-line-height-xs-inner: var(
    --perxis-auto-typography-main-line-height-xs,
    var(--perxis-auto-root-typography-main-line-height-sm-inner)
  );
  --perxis-auto-typography-main-font-size-xxs-inner: var(
    --perxis-auto-typography-main-font-size-xxs,
    var(--perxis-auto-root-typography-main-font-size-xs-inner)
  );
  --perxis-auto-typography-main-line-height-xxs-inner: var(
    --perxis-auto-typography-main-line-height-xxs,
    var(--perxis-auto-root-typography-main-line-height-xs-inner)
  );
  font-family: var(--perxis-auto-typography-main-font-family-inner);
  font-weight: var(--perxis-auto-typography-main-font-weight-inner);
  text-transform: var(--perxis-auto-typography-main-text-transform-inner);
  letter-spacing: var(--perxis-auto-typography-main-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-typography-main-font-variant-numeric-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--main {
    font-size: var(--perxis-auto-typography-main-font-size-xxl-inner);
    line-height: var(--perxis-auto-typography-main-line-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--main {
    font-size: var(--perxis-auto-typography-main-font-size-xl-inner);
    line-height: var(--perxis-auto-typography-main-line-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--main {
    font-size: var(--perxis-auto-typography-main-font-size-lg-inner);
    line-height: var(--perxis-auto-typography-main-line-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--main {
    font-size: var(--perxis-auto-typography-main-font-size-md-inner);
    line-height: var(--perxis-auto-typography-main-line-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--main {
    font-size: var(--perxis-auto-typography-main-font-size-sm-inner);
    line-height: var(--perxis-auto-typography-main-line-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--main {
    font-size: var(--perxis-auto-typography-main-font-size-xs-inner);
    line-height: var(--perxis-auto-typography-main-line-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--main, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--main {
    font-size: var(--perxis-auto-typography-main-font-size-xxs-inner);
    line-height: var(--perxis-auto-typography-main-line-height-xxs-inner);
  }
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--small {
  --perxis-auto-typography-small-font-family-inner: var(
    --perxis-auto-typography-small-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-typography-small-font-variant-numeric-inner: var(
    --perxis-auto-typography-small-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  --perxis-auto-typography-small-font-weight-inner: var(
    --perxis-auto-typography-small-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-typography-small-letter-spacing-inner: var(
    --perxis-auto-typography-small-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-typography-small-text-transform-inner: var(
    --perxis-auto-typography-small-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-typography-small-font-size-xxl-inner: var(
    --perxis-auto-typography-small-font-size-xxl,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-typography-small-line-height-xxl-inner: var(
    --perxis-auto-typography-small-line-height-xxl,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-typography-small-font-size-xl-inner: var(
    --perxis-auto-typography-small-font-size-xl,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-typography-small-line-height-xl-inner: var(
    --perxis-auto-typography-small-line-height-xl,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-typography-small-font-size-lg-inner: var(
    --perxis-auto-typography-small-font-size-lg,
    var(--perxis-auto-root-typography-small-font-size-xl-inner)
  );
  --perxis-auto-typography-small-line-height-lg-inner: var(
    --perxis-auto-typography-small-line-height-lg,
    var(--perxis-auto-root-typography-small-line-height-xl-inner)
  );
  --perxis-auto-typography-small-font-size-md-inner: var(
    --perxis-auto-typography-small-font-size-md,
    var(--perxis-auto-root-typography-small-font-size-lg-inner)
  );
  --perxis-auto-typography-small-line-height-md-inner: var(
    --perxis-auto-typography-small-line-height-md,
    var(--perxis-auto-root-typography-small-line-height-lg-inner)
  );
  --perxis-auto-typography-small-font-size-sm-inner: var(
    --perxis-auto-typography-small-font-size-sm,
    var(--perxis-auto-root-typography-small-font-size-md-inner)
  );
  --perxis-auto-typography-small-line-height-sm-inner: var(
    --perxis-auto-typography-small-line-height-sm,
    var(--perxis-auto-root-typography-small-line-height-md-inner)
  );
  --perxis-auto-typography-small-font-size-xs-inner: var(
    --perxis-auto-typography-small-font-size-xs,
    var(--perxis-auto-root-typography-small-font-size-sm-inner)
  );
  --perxis-auto-typography-small-line-height-xs-inner: var(
    --perxis-auto-typography-small-line-height-xs,
    var(--perxis-auto-root-typography-small-line-height-sm-inner)
  );
  --perxis-auto-typography-small-font-size-xxs-inner: var(
    --perxis-auto-typography-small-font-size-xxs,
    var(--perxis-auto-root-typography-small-font-size-xs-inner)
  );
  --perxis-auto-typography-small-line-height-xxs-inner: var(
    --perxis-auto-typography-small-line-height-xxs,
    var(--perxis-auto-root-typography-small-line-height-xs-inner)
  );
  font-family: var(--perxis-auto-typography-small-font-family-inner);
  font-weight: var(--perxis-auto-typography-small-font-weight-inner);
  text-transform: var(--perxis-auto-typography-small-text-transform-inner);
  letter-spacing: var(--perxis-auto-typography-small-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-typography-small-font-variant-numeric-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--small {
    font-size: var(--perxis-auto-typography-small-font-size-xxl-inner);
    line-height: var(--perxis-auto-typography-small-line-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--small {
    font-size: var(--perxis-auto-typography-small-font-size-xl-inner);
    line-height: var(--perxis-auto-typography-small-line-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--small {
    font-size: var(--perxis-auto-typography-small-font-size-lg-inner);
    line-height: var(--perxis-auto-typography-small-line-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--small {
    font-size: var(--perxis-auto-typography-small-font-size-md-inner);
    line-height: var(--perxis-auto-typography-small-line-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--small {
    font-size: var(--perxis-auto-typography-small-font-size-sm-inner);
    line-height: var(--perxis-auto-typography-small-line-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--small {
    font-size: var(--perxis-auto-typography-small-font-size-xs-inner);
    line-height: var(--perxis-auto-typography-small-line-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--small {
    font-size: var(--perxis-auto-typography-small-font-size-xxs-inner);
    line-height: var(--perxis-auto-typography-small-line-height-xxs-inner);
  }
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--super-small {
  --perxis-auto-typography-super-small-font-family-inner: var(
    --perxis-auto-typography-super-small-font-family,
    var(--perxis-auto-root-typography-super-small-font-family-inner)
  );
  --perxis-auto-typography-super-small-font-variant-numeric-inner: var(
    --perxis-auto-typography-super-small-font-variant-numeric,
    var(--perxis-auto-root-typography-super-small-font-variant-numeric-inner)
  );
  --perxis-auto-typography-super-small-font-weight-inner: var(
    --perxis-auto-typography-super-small-font-weight,
    var(--perxis-auto-root-typography-super-small-font-weight-inner)
  );
  --perxis-auto-typography-super-small-letter-spacing-inner: var(
    --perxis-auto-typography-super-small-letter-spacing,
    var(--perxis-auto-root-typography-super-small-letter-spacing-inner)
  );
  --perxis-auto-typography-super-small-text-transform-inner: var(
    --perxis-auto-typography-super-small-text-transform,
    var(--perxis-auto-root-typography-super-small-text-transform-inner)
  );
  --perxis-auto-typography-super-small-font-size-xxl-inner: var(
    --perxis-auto-typography-super-small-font-size-xxl,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --perxis-auto-typography-super-small-line-height-xxl-inner: var(
    --perxis-auto-typography-super-small-line-height-xxl,
    var(--perxis-auto-root-typography-super-small-line-height-xxl-inner)
  );
  --perxis-auto-typography-super-small-font-size-xl-inner: var(
    --perxis-auto-typography-super-small-font-size-xl,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --perxis-auto-typography-super-small-line-height-xl-inner: var(
    --perxis-auto-typography-super-small-line-height-xl,
    var(--perxis-auto-root-typography-super-small-line-height-xxl-inner)
  );
  --perxis-auto-typography-super-small-font-size-lg-inner: var(
    --perxis-auto-typography-super-small-font-size-lg,
    var(--perxis-auto-root-typography-super-small-font-size-xl-inner)
  );
  --perxis-auto-typography-super-small-line-height-lg-inner: var(
    --perxis-auto-typography-super-small-line-height-lg,
    var(--perxis-auto-root-typography-super-small-line-height-xl-inner)
  );
  --perxis-auto-typography-super-small-font-size-md-inner: var(
    --perxis-auto-typography-super-small-font-size-md,
    var(--perxis-auto-root-typography-super-small-font-size-lg-inner)
  );
  --perxis-auto-typography-super-small-line-height-md-inner: var(
    --perxis-auto-typography-super-small-line-height-md,
    var(--perxis-auto-root-typography-super-small-line-height-lg-inner)
  );
  --perxis-auto-typography-super-small-font-size-sm-inner: var(
    --perxis-auto-typography-super-small-font-size-sm,
    var(--perxis-auto-root-typography-super-small-font-size-md-inner)
  );
  --perxis-auto-typography-super-small-line-height-sm-inner: var(
    --perxis-auto-typography-super-small-line-height-sm,
    var(--perxis-auto-root-typography-super-small-line-height-md-inner)
  );
  --perxis-auto-typography-super-small-font-size-xs-inner: var(
    --perxis-auto-typography-super-small-font-size-xs,
    var(--perxis-auto-root-typography-super-small-font-size-sm-inner)
  );
  --perxis-auto-typography-super-small-line-height-xs-inner: var(
    --perxis-auto-typography-super-small-line-height-xs,
    var(--perxis-auto-root-typography-super-small-line-height-sm-inner)
  );
  --perxis-auto-typography-super-small-font-size-xxs-inner: var(
    --perxis-auto-typography-super-small-font-size-xxs,
    var(--perxis-auto-root-typography-super-small-font-size-xs-inner)
  );
  --perxis-auto-typography-super-small-line-height-xxs-inner: var(
    --perxis-auto-typography-super-small-line-height-xxs,
    var(--perxis-auto-root-typography-super-small-line-height-xs-inner)
  );
  font-family: var(--perxis-auto-typography-super-small-font-family-inner);
  font-weight: var(--perxis-auto-typography-super-small-font-weight-inner);
  text-transform: var(--perxis-auto-typography-super-small-text-transform-inner);
  letter-spacing: var(--perxis-auto-typography-super-small-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-typography-super-small-font-variant-numeric-inner);
}
@media (min-width: 1600px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--super-small {
    font-size: var(--perxis-auto-typography-super-small-font-size-xxl-inner);
    line-height: var(--perxis-auto-typography-super-small-line-height-xxl-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--super-small {
    font-size: var(--perxis-auto-typography-super-small-font-size-xl-inner);
    line-height: var(--perxis-auto-typography-super-small-line-height-xl-inner);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--super-small {
    font-size: var(--perxis-auto-typography-super-small-font-size-lg-inner);
    line-height: var(--perxis-auto-typography-super-small-line-height-lg-inner);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--super-small {
    font-size: var(--perxis-auto-typography-super-small-font-size-md-inner);
    line-height: var(--perxis-auto-typography-super-small-line-height-md-inner);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--super-small {
    font-size: var(--perxis-auto-typography-super-small-font-size-sm-inner);
    line-height: var(--perxis-auto-typography-super-small-line-height-sm-inner);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--super-small {
    font-size: var(--perxis-auto-typography-super-small-font-size-xs-inner);
    line-height: var(--perxis-auto-typography-super-small-line-height-xs-inner);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--super-small, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--super-small {
    font-size: var(--perxis-auto-typography-super-small-font-size-xxs-inner);
    line-height: var(--perxis-auto-typography-super-small-line-height-xxs-inner);
  }
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title a, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph a, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text a, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link a {
  --perxis-auto-typography-link-color-inner: var(--perxis-auto-typography-link-color, inherit);
  --perxis-auto-typography-link-hover-color-inner: var(
      --perxis-auto-typography-link-hover-color,
  var(--perxis-auto-typography-color-light-colorful-inner, var(--perxis-auto-root-typography-color-light-colorful-inner)));
  --perxis-auto-typography-link-decoration-inner: var(--perxis-auto-typography-link-decoration, underline);
  --perxis-auto-typography-link-hover-decoration-inner: var(--perxis-auto-typography-link-hover-decoration, underline);
  color: var(--perxis-auto-typography-link-color-inner);
  text-decoration: var(--perxis-auto-typography-link-decoration-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title a:focus, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title a:hover, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph a:focus, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph a:hover, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text a:focus, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text a:hover, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link a:focus, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link a:hover {
  color: var(--perxis-auto-typography-link-hover-color-inner);
  text-decoration: var(--perxis-auto-typography-link-hover-decoration-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title a:focus svg, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title a:hover svg, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph a:focus svg, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph a:hover svg, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text a:focus svg, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text a:hover svg, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link a:focus svg, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link a:hover svg {
  fill: var(--perxis-auto-typography-link-hover-color-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link {
  --perxis-auto-typography-color-darkest-inner: var(
    --perxis-auto-typography-color-darkest,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-typography-color-dark-inner: var(
    --perxis-auto-typography-color-dark,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  --perxis-auto-typography-color-dark-light-inner: var(
    --perxis-auto-typography-color-dark-light,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-typography-color-light-inner: var(
    --perxis-auto-typography-color-light,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-typography-color-lightest-inner: var(
    --perxis-auto-typography-color-lightest,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  --perxis-auto-typography-color-darkest-colorful-inner: var(
    --perxis-auto-typography-color-darkest-colorful,
    var(--perxis-auto-root-typography-color-darkest-colorful-inner)
  );
  --perxis-auto-typography-color-dark-colorful-inner: var(
    --perxis-auto-typography-color-dark-colorful,
    var(--perxis-auto-root-typography-color-dark-colorful-inner)
  );
  --perxis-auto-typography-color-dark-light-colorful-inner: var(
    --perxis-auto-typography-color-dark-light-colorful,
    var(--perxis-auto-root-typography-color-dark-light-colorful-inner)
  );
  --perxis-auto-typography-color-light-colorful-inner: var(
    --perxis-auto-typography-color-light-colorful,
    var(--perxis-auto-root-typography-color-light-colorful-inner)
  );
  --perxis-auto-typography-color-lightest-colorful-inner: var(
    --perxis-auto-typography-color-lightest-colorful,
    var(--perxis-auto-root-typography-color-lightest-colorful-inner)
  );
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--darkest, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--darkest, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--darkest, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--darkest {
  color: var(--perxis-auto-typography-color-darkest-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--dark, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--dark, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--dark, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--dark {
  color: var(--perxis-auto-typography-color-dark-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--dark-light, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--dark-light, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--dark-light, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--dark-light {
  color: var(--perxis-auto-typography-color-dark-light-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--light, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--light, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--light, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--light {
  color: var(--perxis-auto-typography-color-light-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--lightest, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--lightest, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--lightest, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--lightest {
  color: var(--perxis-auto-typography-color-lightest-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--darkest-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--darkest-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--darkest-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--darkest-colorful {
  color: var(--perxis-auto-typography-color-darkest-colorful-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--dark-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--dark-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--dark-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--dark-colorful {
  color: var(--perxis-auto-typography-color-dark-colorful-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--dark-light-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--dark-light-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--dark-light-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--dark-light-colorful {
  color: var(--perxis-auto-typography-color-dark-light-colorful-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--light-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--light-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--light-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--light-colorful {
  color: var(--perxis-auto-typography-color-light-colorful-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-title--lightest-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-paragraph--lightest-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-text--lightest-colorful, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link--lightest-colorful {
  color: var(--perxis-auto-typography-color-lightest-colorful-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link {
  --perxis-auto-typography-link-color-inner: var(--perxis-auto-typography-link-color, inherit);
  --perxis-auto-typography-link-hover-color-inner: var(
      --perxis-auto-typography-link-hover-color,
  var(--perxis-auto-typography-color-light-colorful-inner, var(--perxis-auto-root-typography-color-light-colorful-inner)));
  --perxis-auto-typography-link-decoration-inner: var(--perxis-auto-typography-link-decoration, underline);
  --perxis-auto-typography-link-hover-decoration-inner: var(--perxis-auto-typography-link-hover-decoration, underline);
  color: var(--perxis-auto-typography-link-color-inner);
  text-decoration: var(--perxis-auto-typography-link-decoration-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link:focus, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link:hover {
  color: var(--perxis-auto-typography-link-hover-color-inner);
  text-decoration: var(--perxis-auto-typography-link-hover-decoration-inner);
}
.perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link:focus svg, .perxis-auto-1_17_2-typography.ant-5_24_1-typography.perxis-auto-1_17_2-link:hover svg {
  fill: var(--perxis-auto-typography-link-hover-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
